<template>
    <j-modal
      :title="title"
      :width="width"
      :visible="visible"
      switchFullscreen
      @ok="handleOk"
      :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
      @cancel="handleCancel"
      cancelText="关闭"
    >
      <teaching-user-course-hour-form
        ref="realForm"
        @ok="submitCallback"
        :disabled="disableSubmit"
        :type="type"
      ></teaching-user-course-hour-form>
    </j-modal>
  </template>
  
  <script>
  import TeachingUserCourseHourForm from './TeachingUserCourseHourForm'
  export default {
    name: 'TeachingUserCourseHourModal',
    components: {
      TeachingUserCourseHourForm,
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false,
        type: 'detail', // detail charge spend
      }
    },
    methods: {
      chargeDepart() {
        this.visible = true
        this.type = 'chargeDepart'
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      chargeUser(record) {
        this.visible = true
        this.type = 'chargeUser'
        let param = {}
        param.courseHour = record.courseHour
        param.departId = record.departId
        param.userId = record.userId
        this.$nextTick(() => {
          this.$refs.realForm.edit(param)
        })
      },
      spendDepart() {
        this.visible = true
        this.type = 'spendDepart'
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      spendUser(record) {
        this.visible = true
        this.type = 'spendUser'
        let param = {}
        param.courseHour = record.courseHour
        param.departId = record.departId
        param.userId = record.userId
        this.$nextTick(() => {
          this.$refs.realForm.edit(param)
        })
      },
      add() {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add()
        })
      },
      edit(record) {
        this.visible = true
        this.type = 'detail'
        this.$nextTick(() => {
          this.$refs.realForm.edit(record)
        })
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        this.$refs.realForm.submitForm()
      },
      submitCallback() {
        this.$emit('ok')
        this.visible = false
      },
      handleCancel() {
        this.close()
      },
    },
  }
  </script>